import React from 'react';
import PropTypes from 'prop-types';
import Styled from 'styled-components';
import Colors from '../common/NekoTheme';
import Theme from '../common/NekoTheme';

const Tag = Styled.a`
  background-color: ${Colors.yellow};
  position: relative;
  border-radius: 10px;
  color: ${Colors.white};
  font-family: ${Theme.fontFamily};
  font-size: 9px;
  line-height: 10px;
  padding: 5px 8px;
  text-transform: uppercase;
  text-decoration: none;

  &:hover {
    color: ${Colors.white};
    background-color: #f78c1f;
  }

  &.inline {
    display: inline;
    margin-left: 5px;
    vertical-align: middle;
  }
`;

/**
 * @param {string} className
 * @param {string|object} icon
 * @param {bool} disabled
 * @param {function} onClick
 */
const StyledProOnly = (props) => {

  const { show = true, className, ...rest } = props;

  if (!show) {
    return null;
  }

  return (
    <Tag href='https://store.meowapps.com' target='_blank' className={`${className || ''}`} {...rest}>
      Pro Only
    </Tag>
  );
};

const ProOnly = (props) => {
  return (<StyledProOnly {...props} />);
}

ProOnly.propTypes = {
  show: PropTypes.bool,
  className: PropTypes.string
};

ProOnly.defaultProps = {
  show: true,
  className: undefined
};

export { ProOnly };
